import { useState, useEffect } from "react";

import shiftCreditCardService from "../../services/shiftCreditCardService";
import { Button } from "react-bootstrap";
import AvailableForCreditCardSaveShift from "./availableForCreditCardSaveShift";
import { IAvailableForCreditCardSaveShift, ICompanyBank } from "./interface";
import Modal from "../modal";
import "./shiftcreditcardpost.css";
import ReactPaginate from "react-paginate";
import { useHistory, useLocation } from "react-router-dom";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { actionCreators, State } from "../../state/index";
import { bindActionCreators } from "redux";

interface IProps {
  language: any;
  message: string;
  history: any;
}

const ShiftCreditCardPost = (props: IProps) => {
  const [
    availableForCreditCardSaveShifts,
    setAvailableForCreditCardSaveShifts,
  ] = useState<IAvailableForCreditCardSaveShift[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isFetchFailed, setIsFetchFailed] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(5);
  const [pageCount, setPageCount] = useState(0);
  const [offset, setOffset] = useState(0);
  const [failResponseMessage, setFailResponseMessage] = useState<any>();
  const [languageData, setLanguageData] = useState<any>();
  const history = useHistory();

  // Redux
  const dispatch = useDispatch();
  const { login, logout, register } = bindActionCreators(
    actionCreators.authActions,
    dispatch
  );
  const state = useSelector((state: State) => state);
  const { isLoggedIn } = state.authReducer;
  const stateLanguage = state.languageReducer;

  const id = useQuery().get("shiftsentityid");

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  useEffect(() => {
    console.log("new one", isLoggedIn);
    if (!isLoggedIn) {
      history.push("/login");
    }
  }, []);

  useEffect(() => {
    setLanguageData(stateLanguage);
  }, [stateLanguage]);

  useEffect(() => {
    fetchAvailableForCreditCardSaveShifts(id);
  }, [id]);

  const fetchAvailableForCreditCardSaveShifts = async (id: any) => {
    setIsFetchFailed(false);
    setIsLoading(true);
    try {
      const response: any =
        await shiftCreditCardService.getAvailableForCreditCardSaveShifts(id);
      console.log(response);
      const updatedResponse = response.data.map((shift: any) => {
        const updatedCompanyBank = shift.companyBanks.map(
          (bank: any, index: number) => {
            return {
              ...bank,
              domId: index,
              amount: 0,
              batchNo: "",
              removable: false,
            };
          }
        );
        return {
          ...shift,
          companyBanks: updatedCompanyBank,
          isInputHidden: true,
          isSaving: false,
          isPostFailed: false,
        };
      });
      console.log(updatedResponse);
      setAvailableForCreditCardSaveShifts(updatedResponse);
      setIsLoading(false);
      setPageCount(Math.ceil(response.data.length / perPage));
    } catch (e: any) {
      checkForTokenStatus(e);
      console.dir(e);

      if (e.response) {
        if (e.response.status === 401) {
          if (isLoggedIn) {
            dispatch(actionCreators.authActions.logout());
          }
          history.push("/login");
        }

        if (e.response.status === 423) {
          setFailResponseMessage(e.response.data);
        }

        if (e.response.status === 403) {
          setFailResponseMessage({ message: e.response.data.error });
        }
      }

      if (!e.response) {
        setIsFetchFailed(true);
      }

      console.dir(e);

      setIsLoading(false);
    }
  };

  const handlePageClick = (e: any) => {
    const selectedPage = e.selected;
    console.log(e.selected);
    const offset = selectedPage * perPage;
    console.log(offset);

    setCurrentPage(selectedPage);
    setOffset(offset);
  };

  /**
   * If token expired redirect to /login
   * @param error
   */
  const checkForTokenStatus = (error: any) => {
    if (error.response && error.response.status === 401) {
      if (isLoggedIn) {
        dispatch(actionCreators.authActions.logout());
      }
      history.push("/login");
    }
  };

  const handleBatchNoChange = (
    shiftId: number,
    bankId: number,
    element: any,
    domId: number
  ) => {
    const updatedShift = availableForCreditCardSaveShifts.map((shift) => {
      if (shift.shiftId === shiftId) {
        shift.companyBanks.map((bank) => {
          if (bankId === bank.bankId && bank.domId === domId) {
            bank.batchNo = element.target.value;
            return bank;
          }
          return bank;
        });
        return shift;
      }
      return shift;
    });
    setAvailableForCreditCardSaveShifts(updatedShift);
  };

  const handleAmountChange = (
    shiftId: number,
    bankId: number,
    element: any,
    domId: number
  ) => {
    const updatedShift = availableForCreditCardSaveShifts.map((shift) => {
      if (shift.shiftId === shiftId) {
        shift.companyBanks.map((bank) => {
          if (bankId === bank.bankId && bank.domId === domId) {
            bank.amount = Number.parseFloat(element.target.value);
            return bank;
          }
          return bank;
        });
        return shift;
      }
      return shift;
    });
    setAvailableForCreditCardSaveShifts(updatedShift);
  };

  const handleToggleButtonClick = (shiftId: number) => {
    console.log(shiftId);
    const updatedShift = availableForCreditCardSaveShifts.map(
      (shift: IAvailableForCreditCardSaveShift) => {
        if (shift.shiftId === shiftId) {
          shift.isInputHidden = !shift.isInputHidden;
          return shift;
        }
        return shift;
      }
    );
    setAvailableForCreditCardSaveShifts(updatedShift);
  };

  const handleSaveButtonClick = async (
    shiftId: number,
    shiftsEntityId: number
  ) => {
    const beforePostUpdatedShifts = availableForCreditCardSaveShifts.map(
      (shift) => {
        if (shift.shiftId === shiftId) {
          shift.isSaving = true;
          shift.isPostFailed = false;
          return shift;
        }
        return shift;
      }
    );
    console.log(beforePostUpdatedShifts);
    setAvailableForCreditCardSaveShifts(beforePostUpdatedShifts);

    const theShift: IAvailableForCreditCardSaveShift[] =
      availableForCreditCardSaveShifts.filter((shift) => {
        if (shift.shiftId === shiftId) {
          return true;
        }
        return false;
      });

    if (theShift.length !== 1) {
      throw new Error("Array should return 1 value.");
    }

    console.log("theShift", theShift);
    const payload = theShift[0].companyBanks.map((bank: ICompanyBank) => {
      return {
        shiftId: theShift[0].shiftsEntityId,
        companyBankId: bank.companyBankId,
        batchId: bank.batchNo,
        amount: bank.amount,
      };
    });
    console.log("payLoad", payload);
    try {
      const response =
        await shiftCreditCardService.postAvailableForCreditCardSaveShift(
          payload
        );
      const updateAvailableForCreditCardSaveShifts: IAvailableForCreditCardSaveShift[] =
        availableForCreditCardSaveShifts.filter((shift) => {
          if (shift.shiftId === theShift[0].shiftId) {
            return false;
          }
          return true;
        });
      setAvailableForCreditCardSaveShifts(
        updateAvailableForCreditCardSaveShifts
      );
      if (id) {
        history.push("/shiftreview?shiftsentityid=" + shiftsEntityId);
      }
    } catch (err) {
      console.dir(err);
      checkForTokenStatus(err);
      const beforePostUpdatedShifts = availableForCreditCardSaveShifts.map(
        (shift) => {
          if (shift.shiftId === shiftId) {
            shift.isSaving = false;
            shift.isPostFailed = true;
            return shift;
          }
          return shift;
        }
      );
      console.log(beforePostUpdatedShifts);
      setAvailableForCreditCardSaveShifts(beforePostUpdatedShifts);
    }
  };

  const handleNewBankAdded = (bank: ICompanyBank, shiftId: number) => {
    console.log(bank);
    const updatedShifts = availableForCreditCardSaveShifts.map(
      (shift: IAvailableForCreditCardSaveShift) => {
        if (shift.shiftId === shiftId) {
          shift.companyBanks = [...shift.companyBanks, bank];
          return shift;
        }
        return shift;
      }
    );
    setAvailableForCreditCardSaveShifts(updatedShifts);
  };

  const handleRemoveNewBank = (bank: ICompanyBank, shiftId: number) => {
    const updatedShifts = availableForCreditCardSaveShifts.map(
      (shift: IAvailableForCreditCardSaveShift) => {
        if (shift.shiftId === shiftId) {
          const updatedCompanyBanks = shift.companyBanks.filter(
            (theBank: ICompanyBank) => {
              if (bank.domId === theBank.domId) {
                return false;
              }
              return true;
            }
          );
          shift.companyBanks = updatedCompanyBanks;
          return shift;
        }
        return shift;
      }
    );
    setAvailableForCreditCardSaveShifts(updatedShifts);
  };

  const toggleIsFetchFailedModal = () => {
    setIsFetchFailed(!isFetchFailed);
  };

  const spinner = (
    <div>
      <div className="d-flex justify-content-center ">
        <div className="spinner-border spinner" role="status"></div>
      </div>
      <div
        style={{ marginTop: "1.5%" }}
        className="d-flex justify-content-center"
      >
        <p style={{ fontStyle: "oblique" }}>{languageData?.data?.shiftCreditCard?.loading}</p>
      </div>
    </div>
  );

  const slice = availableForCreditCardSaveShifts.slice(
    offset,
    offset + perPage
  );
  const shifts = slice.map(
    (shift: IAvailableForCreditCardSaveShift, index: number) => {
      console.log("initialized");
      return (
        <AvailableForCreditCardSaveShift
          key={shift.shiftId}
          shift={shift}
          onBatchNoInputChange={handleBatchNoChange}
          onAmountInputChange={handleAmountChange}
          toggleButtonClicked={handleToggleButtonClick}
          saveButtonClicked={handleSaveButtonClick}
          newBankAdded={handleNewBankAdded}
          removeNewBank={handleRemoveNewBank}
        />
      );
    }
  );

  return (
    <div>
      {failResponseMessage && (
        <div>
          <h1>{failResponseMessage.message}</h1>
          {failResponseMessage.details &&
            failResponseMessage.details.map((detail: any) => {
              return <h4>{detail}</h4>;
            })}
        </div>
      )}
      {!failResponseMessage && (
        <div>
          <h1>{languageData?.data?.shiftCreditCard?.availableShiftsH1}</h1>
          <div className={"pagination-wrapper"}>
            {isLoading && spinner}
            {isFetchFailed && (
              <div>
                <h4>{languageData?.data?.shiftCreditCard?.noShiftAvailable}</h4>
              </div>
            )}
            {availableForCreditCardSaveShifts.length === 0 &&
            isFetchFailed === false &&
            isLoading === false ? (
              <div>
                <h4>{languageData?.data?.shiftCreditCard?.noShiftAvailable}</h4>
                <div className={"deposit-button-wrapper"}>
                  <Button
                    className={"deposit-button"}
                    onClick={fetchAvailableForCreditCardSaveShifts}
                  >
                    {languageData?.data?.shiftCreditCard?.loadShifts}
                  </Button>
                </div>
              </div>
            ) : null}
            {shifts}
            <ReactPaginate
              previousLabel={languageData?.data?.general?.pagination?.prev}
              nextLabel={languageData?.data?.general?.pagination?.next}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-center"}
              activeClassName={"active"}
            />
          </div>
        </div>
      )}

      <Modal
        show={isFetchFailed}
        handleClose={toggleIsFetchFailedModal}
        onTrue={fetchAvailableForCreditCardSaveShifts}
        buttonText={languageData?.data?.general?.modal?.retry?.button}
        question={languageData?.data?.general?.modal?.retry?.question}
      />
    </div>
  );
};

export default ShiftCreditCardPost;
